<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="documentType.title"
          :link="[
            {
              text: role.type === 'teacher' ? 'Báo cáo chuyên môn' : 'Sổ sách cá nhân của GV',
              href: '../teacherDocumentTypes'
            }
          ]"
        />
      </div>
      <div class="flex-center" v-if="role.type === 'teacher'">
        <v-btn color="primary" class="elevation-0" @click="upload">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
    </div>

    <div v-if="role.type !== 'teacher'">
      <v-card class="mx-4 mb-6 pa-6" outlined>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <CheckboxAcademicLevel :isDefaultCheckAll="false" @change="academicLevelChanged" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="5">
            <AutocompleteSubjectGroup
              v-model="subjectGroup"
              clear-icon="mdi-close"
              label="Lĩnh vực"
              item-text="title"
              outlined
              dense
              return-object
              hide-details
              @change="subjectGroupChanged"
            />
          </v-col>
          <v-col cols="12" md="5">
            <AutocompleteTeacherCard
              :syncedValue.sync="teacher"
              item-text="name"
              clear-icon="mdi-close"
              label="Giáo viên"
              outlined
              dense
              deletable-chips
              hide-details
              :displaySubjectGroup="true"
              :filter="teacherFilter"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn height="40" color="#0D47A1" @click="search" outlined>
              Chọn xem
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-card outlined class="mx-4 elevation-0">
      <div class="d-flex align-center justify-space-between px-6 py-4" v-if="selecteds && selecteds.length">
        <div class="d-flex flex-column">
          <span>
            {{ 'Đã chọn ' + selecteds.length + ' file' }}
          </span>
        </div>

        <v-btn small color="primary" @click="removeFiles">Xóa file</v-btn>
      </div>
      <TeacherDocumentDataTable :selected.sync="selecteds" ref="table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeacherDocumentDataTable from '@/modules/document/TeacherDocumentDataTable.vue'
import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'

export default {
  components: {
    Breadcrumbs,
    TeacherDocumentDataTable,
    AutocompleteTeacherCard,
    CheckboxAcademicLevel,
    AutocompleteSubjectGroup
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      teacher: '',
      documentType: {},
      selecteds: [],
      subjectGroup: {},
      academicLevels: []
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user']),

    teacherFilter() {
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        return {
          academicLevels_in: this.academicLevels.map(a => a.id),
          subjectGroup: get(this.subjectGroup, 'id')
        }
      }

      return { subjectGroup: get(this.subjectGroup, 'id') }
    }
  },
  async created() {
    this.typeId = this.$route.params.id
    this.documentType = await this.fetchDocumentType(this.typeId)
  },
  methods: {
    ...mapActions('Documents', ['createDocument', 'removeDocument', 'removeDocuments', 'fetchDocumentType']),
    ...mapActions('upload', ['uploadFile']),
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
      this.teacher = null
    },
    subjectGroupChanged(subjectGroup) {
      this.subjectGroup = subjectGroup
      if (subjectGroup && subjectGroup.id) {
        this.teacher = null
      }
    },
    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      if (this.role.type === 'teacher') {
        this.$loading.active = true
        const file = e.target.files[0]

        let createdDocument = {}
        try {
          // create document
          const data = {
            documentType: this.typeId,
            createdTeacher: this.profile.id,
            createdUser: this.user.id
          }
          createdDocument = await this.createDocument(data)
          // upload file
          let formData = new FormData()
          formData.append('files', file)
          formData.append('refId', createdDocument.id)
          formData.append('ref', 'document')
          formData.append('field', 'file')

          await this.uploadFile(formData)

          this.$alert.success('Tải file thành công')
          await this.$refs.table.refresh({ createdTeacher: this.profile.id, documentType: this.typeId })
        } catch (error) {
          this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
          if (createdDocument.id) await this.removeDocument(createdDocument.id)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async search() {
      const params = { createdTeacher: this.teacher && this.teacher.id, documentType: this.typeId }
      if (this.role.type === 'teacher') {
        params.createdTeacher = this.profile.id
      }
      if (this.subjectGroup && this.subjectGroup.id) params['createdTeacher.subjectGroup'] = this.subjectGroup.id
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        params['createdTeacher.academicLevels_in'] = this.academicLevels.map(a => a.id)
      }

      await this.$refs.table.refresh(params)
    },
    async removeFiles() {
      this.$dialog.confirm({
        title: 'Xóa tài liệu',
        text: `Bạn có chắc muốn xóa ${this.selecteds && this.selecteds.length} tài liệu này không ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeDocuments(this.selecteds.map(f => f.id))
            await this.search()
            this.$alert.deleteSuccess()
            this.selecteds = []
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style scoped></style>
